
import Vue from "vue";
import Memory from '../../views/Dashboard/Memory.vue';
import Storage from '../../views/Dashboard/Storage.vue';
import { mapGetters } from "vuex";
import axios from 'axios';
import * as action from "@/store/actions";
export default Vue.extend({
	data: () => ({
		menu: false,
		diskUsage: 0,
		memoryUsage: 64,
	}),
	components: {
		Memory,
		Storage,
	},
	computed: {
		...mapGetters({
			menuFontColor: "lookAndFeel/menuFontColor",
		})
	},
	mounted() {
		this.fetchData();
		this.intervalId = setInterval(this.fetchData, 50000);
	},
	methods: {

		beforeDestroy() {
			if (this.intervalId) {
				clearInterval(this.intervalId);
			}
		},
		async fetchData() {
			try {
				const token = localStorage.getItem('token');

				const res = await axios.get(action.GET_INFOPC, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				const usada = res.data.usada;
				const disponible = res.data.disponible;
				const usadoDisco = res.data.usadoDisco;
				const disponibleDisco = res.data.disponibleDisco;

				this.diskUsage = Math.round((usada / (usada + disponible)) * 100);
				this.memoryUsage = Math.round((usadoDisco / (usadoDisco + disponibleDisco)) * 100);

			} catch (error) {
				console.error('Error al obtener datos:', error);
			}
		},
	},

});
